import { Grid, useTheme } from "@mui/material";

const ProgressBlock = ({ completed = false }) => {
  const theme = useTheme();
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        background: completed
          ? theme.palette.secondary.main
          : theme.palette.mode === "light"
          ? "rgba(0,0,0,0.1)"
          : "rgba(0,0,0,0.4)",
      }}
    ></div>
  );
};

const CurrentBlock = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        background: theme.palette.mode === "light" ? "rgba(41,40,129,0.5)" : "rgba(0,189,255,0.4)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <span
        style={{
          position: "absolute",
          display: "block",
          top: 0,
          left: "-100%",
          width: "100%",
          height: "100%",
          background: `linear-gradient(90deg, transparent, ${theme.palette.secondary.main})`,
          animation: "progressBarAnimationTop 4s linear infinite",
        }}
      ></span>
    </div>
  );
};

const ProgressBar: React.FC<{
  steps: number;
  filledSteps: number;
  animateCurrent: boolean;
}> = ({ steps, filledSteps, animateCurrent = false }) => {
  let uncompletedBlocksCount;
  if (steps - filledSteps > 0) {
    if (animateCurrent) {
      uncompletedBlocksCount = steps - filledSteps - 1;
    } else {
      uncompletedBlocksCount = steps - filledSteps;
    }
  } else {
    uncompletedBlocksCount = 0;
  }
  return (
    <Grid
      container
      style={{
        height: 8,
        overflow: "hidden",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
        gridGap: 3,
      }}
    >
      {[...Array(filledSteps)].map((e, i) => (
        <ProgressBlock completed key={i} />
      ))}
      {animateCurrent ? <CurrentBlock /> : null}
      {[...Array(uncompletedBlocksCount)].map((e, i) => (
        <ProgressBlock key={i} />
      ))}
    </Grid>
  );
};

export default ProgressBar;
